import styled from 'styled-components'

import { Box, Flex } from 'app/components/design-system-components'
import { mediaQueries } from 'app/components/design-system-components/styles/variables'
import RentBondLogoAndDesc from 'app/Integrations/components/RentBond/components/ImageAndText'
import RentBondPreApprovedButton from 'app/Integrations/components/RentBond/components/PreApprovedButton'
import type { RentBondBannerProps } from 'app/Integrations/components/RentBond/types'
import theme from 'app/match/applicationReportPDF/assets/theme'

const StyledRentBondPreApprovedButton = styled(RentBondPreApprovedButton)`
  ${mediaQueries.sm} {
    margin-top: ${theme.space[4]}px;
    max-width: unset;
  }
`

const StyledFlex = styled(Flex)`
  line-height: 140%;
  color: ${theme.colors.gray800};
  .text {
    width: 70%;
    margin-right: ${theme.space[3]}px;
  }
  .image {
    width: ${theme.width[31]}px;
  }
  justify-content: space-between;
  ${mediaQueries.sm} {
    flex-direction: column;
    width: 100%;
    text-align: center;
    justify-content: unset;
    .text {
      width: 100%;
    }
    .image {
      width: 100%;
      margin-top: ${theme.space[5]}px;
    }
  }
`

function RentBondBanner({
  className = '',
  linkParam = '',
}: RentBondBannerProps) {
  return (
    <StyledFlex alignItems="center" p={5}>
      <Box className="text">
        <RentBondLogoAndDesc />
      </Box>
      <Box className="image">
        <StyledRentBondPreApprovedButton
          className={className}
          linkParam={linkParam}
        />
      </Box>
    </StyledFlex>
  )
}

export default RentBondBanner
